export default __webpack_public_path__ + "static/media/search.6fc1a009.svg";